export enum UserStatusLevel {
  Customer,
  Employee,
  VIP
}
